import React, { useContext, useMemo } from 'react';
import { VisitsGlobalContext } from '@mummssoftware/global-context';
import { FormControl, MenuItem, Select, makeStyles } from '@material-ui/core';
import { ALL } from '@mummssoftware/utils/constants';
import { AppContext } from '../../context';
import {
  FilterHeader,
  FilterContainer,
} from '../../components/layout/WrapperDiv';
import { total, filterByOffice } from '../../translations/en.json';
import { SummaryFilterContext } from './SummaryFilters';

const listAttributeMenuItems = (attributes: string[]) =>
  attributes.map((el) => (
    <MenuItem key={`attribute-${el}`} value={el} style={{ fontSize: '.85rem' }}>
      {el}
    </MenuItem>
  ));

export const OfficeFilter = () => {
  const { officeFilter, crossPatientVisitSummary } = useContext(
    VisitsGlobalContext,
  );
  const { patient } = useContext(AppContext);
  const { tentativeFilters, updateTentFilters } = useContext(
    SummaryFilterContext,
  );

  const siteOffices = useMemo(() => {
    const officeList = [ALL];
    if (crossPatientVisitSummary) {
      crossPatientVisitSummary.forEach((provider: any) => {
        if (
          provider.siteoffice &&
          provider.siteoffice !== total &&
          !officeList.includes(provider.siteoffice)
        ) {
          officeList.push(provider.siteoffice);
        }
      });
    }
    return officeList;
  }, [crossPatientVisitSummary]);

  const setOffice = (office: any) => {
    updateTentFilters({ ...tentativeFilters, officeFilter: office });
  };

  const officeChanged = officeFilter !== String(tentativeFilters.officeFilter);

  const useStyles = makeStyles((theme) => ({
    select: {
      '&:before': {
        borderColor:
          (officeChanged && `${(theme as any).palette.text.secondary}`) ||
          `${(theme as any).palette.text.primary}`,
      },
      '&:after': {
        borderColor: `${(theme as any).palette.text.secondary}`,
      },
    },
    icon: {
      fill:
        (officeChanged && `${(theme as any).palette.text.secondary}`) ||
        `${(theme as any).palette.text.primary}`,
    },
    root: {
      color:
        (officeChanged && `${(theme as any).palette.text.secondary}`) ||
        `${(theme as any).palette.text.primary}`,
    },
  }));

  const classes = useStyles();

  return (
    <FilterContainer className="visit-log-office-filter">
      <FilterHeader selected={officeChanged}>{filterByOffice}</FilterHeader>
      {!patient && (
        <div style={{ display: 'flex', paddingTop: '5px' }}>
          <React.Fragment>
            <FormControl style={{ paddingLeft: '3px', minWidth: '70px' }}>
              <Select
                style={{ fontSize: '.85rem' }}
                className={classes.select}
                inputProps={{
                  classes: {
                    icon: classes.icon,
                    root: classes.root,
                  },
                }}
                value={tentativeFilters.officeFilter}
                onChange={(event) => setOffice(event.target.value as string)}
              >
                {siteOffices && listAttributeMenuItems(siteOffices)}
              </Select>
            </FormControl>
          </React.Fragment>
        </div>
      )}
    </FilterContainer>
  );
};
